import { SlideInRight, SlideOutRight } from 'react-native-reanimated';

const animations = {
  slideInRight: SlideInRight,
  slideOutRight: SlideOutRight,
};

export default animations;
